<template>
    <div>
        <v-container class="white ma-0 pa-0" v-if="possuiRegistroDeAjuste">
            <div class="pt-5 pl-5" style="max-width: 200px">
                <v-tooltip
                    :disabled="verificaPermissaoCriacao"
                    right
                    max-width="200">
                    <template v-slot:activator="{ on }">
                        <div v-on="on">
                            <v-btn
                                @click="abrirModalNovoAjuste"
                                color="primary"
                                class="call-to-action text-body-2"
                                :disabled="!verificaPermissaoCriacao">
                                Novo Ajuste
                                <v-icon right dark>
                                    add
                                </v-icon>
                            </v-btn>
                        </div>
                    </template>
                    <span>Não é possível realizar ajustes em patrimônios baixados ou que atingiram o fim da vida útil.</span>
                </v-tooltip>
            </div>
        </v-container>
        <v-container class="white d-flex justify-center align-center" style="min-height:66vh;" v-else>
            <div class="text-center mb-12">
                <p class="az-title__subtitle">
                    Nenhum
                    <span class="session-title">ajuste</span>
                    realizado, clique para adicionar
                </p>

                <v-tooltip
                    :disabled="verificaPermissaoCriacao"
                    bottom
                    max-width="290">
                    <template v-slot:activator="{ on }">
                        <div v-on="on" :class="{'btn-disabled': !patrimonio.tipo}">
                            <v-btn
                                @click="abrirModalNovoAjuste"
                                color="primary"
                                class="call-to-action text-body-2"
                                :disabled="!verificaPermissaoCriacao">
                                Novo Ajuste
                                <v-icon right dark>
                                    add
                                </v-icon>
                            </v-btn>
                        </div>
                    </template>
                    Não é possível realizar ajustes em patrimônios baixados ou que atingiram o fim da vida útil.
                </v-tooltip>
            </div>
        </v-container>
    </div>
</template>

<script>
    import {createNamespacedHelpers, mapState} from 'vuex'
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import moment from 'moment'

    const {mapGetters} = createNamespacedHelpers('CamposPersonalizados')

    export default {
        name: 'BotaoNovoAjuste',
        props: ['possuiRegistroDeAjuste'],
        data() {
            return {
                tipo: ''
            }
        },
        computed: {
            ...mapState({patrimonio: state => state.patrimonio.patrimonio}),
            ...mapGetters(['getTooltipCamposPersonalizados']),

            verificaPermissaoCriacao() {
                const temPermissao = AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
                const naoBaixado = this.patrimonio.situacao !== 'BAIXADO'
                const vidaUtilIndefinida = this.patrimonio.vidaIndefinida
                const vencimentoValido = vidaUtilIndefinida === true
                    || moment(this.patrimonio.fimVidaUtil).isAfter(moment(new Date()))

                return temPermissao && naoBaixado && vencimentoValido
            }

        },
        methods: {
            async abrirModalNovoAjuste() {
                this.$emit('abrirModalNovoAjuste')
            },
            cadastrarAjuste() {
                this.$emit('cadastrarAjuste', this.tipo)
                this.tipo = ''
            }
        }
    }
</script>
